import { useEffect, useContext } from "react";
import { UserContext } from "../stores/contexts/userContext";
import { logout } from "../stores/api_calls/authentications";
import { useNavigate } from 'react-router-dom'

const SessionHandler = () => {
  const [userConfig, setUserConfig] = useContext(UserContext);
  let navigate = useNavigate();

  useEffect(() => {
    if (!userConfig?.isLoggedIn) return;

    const expiry = Number(localStorage.getItem("expiry"));

    const checkSession = () => {
      if (expiry && Date.now() > expiry) {
        handleLogout("Session expired after 4 hours");
      }
    };

    // check every minute
    const interval = setInterval(checkSession, 60 * 1000);

    // logout when browser/tab closes
    const handleBeforeUnload = () => {
      handleLogout("Browser/tab closed");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [userConfig]);

  const handleLogout = async (reason) => {
    const signOut = logout()
    signOut.then((res)=>{
        if(res.data.success){
          setUserConfig({...userConfig,isLoggedIn:false  , userDetails:{}})
          localStorage.removeItem("token");
          localStorage.removeItem("loginTime");
          localStorage.removeItem("expiry");
          navigate("../login", { replace: true })
        }
    }).catch((e)=>{
        console.log(e)
    })

    // try {
    //   await logout();
    // } catch (e) {
    //   console.error("Logout error:", e);
    // } finally {
    //   console.log(reason);
    //   setUserConfig({...userConfig,isLoggedIn:false  , userDetails:{}})
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("loginTime");
    //   localStorage.removeItem("expiry");
    //   navigate("../login", { replace: true })
    // }
  };

  return null;
};

export default SessionHandler;